export const VALUATION_OBLIGATION_CATEGORIES = [
  { id: 'PAYMENT', displayValue: 'Payment' },
  { id: 'BORROWED_MONEY', displayValue: 'Borrowed Money' },
  { id: 'BOND', displayValue: 'Bond' },
  { id: 'LOAN', displayValue: 'Loan' },
  { id: 'BOND_OR_LOAN', displayValue: 'Bond or Loan' },
];
